import Link from '@/components/core/Link';
import { CasinoBannerProps } from './props';
import styles from './styles.module.scss';
import { Image } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';
import Color from 'color';

function CasinoBanner({ item }: CasinoBannerProps) {
  const { t } = useTranslation('common');

  return (
    <Link href={item?.link}>
      <div
        className={styles.container}
        style={{
          //@ts-ignore
          '--banner-color': item.color,
          '--banner-color-2': Color(item.color).darken(0.5).toString(),
        }}
      >
        <Image
          className={styles.container__image}
          src={item?.image}
          key={`casino-banner-${item?.id}`}
          alt={`casino-banner-image-${item?.link}`}
          format="rectangle"
          width={400}
          bundle={item.id < 4}
          loading={item.id < 4 ? 'eager' : 'lazy'}
          height={200}
        />
        <div className={styles.container__wrapper}>
          <div className={styles.container__content}>
            <div className={styles.container__wrapper__title}>
              {t(item.title)}
            </div>
            <div className={styles.container__wrapper__description}>
              {t(item.description)}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default memo(CasinoBanner);
